import type { ClassList } from "../../types";
import { Show, type VoidComponent } from "solid-js";

type HandleBarProps = { expandDragArea?: boolean; classList?: ClassList };

const Handlebar: VoidComponent<HandleBarProps> = (props) => (
  <div class="relative" data-testid="handlebar" classList={props.classList}>
    <Show when={props.expandDragArea}>
      <span class="absolute top-1/2 -left-1.5 h-8 w-5 -translate-y-1/2" aria-hidden="true" />
    </Show>
    <svg
      width="8"
      height="13"
      viewBox="0 0 8 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="shrink-0 icon-tertiary"
      aria-hidden={true}
    >
      <circle cx="1.5" cy="1.5" r="1.5" fill="currentColor" />
      <circle cx="1.5" cy="6.5" r="1.5" fill="currentColor" />
      <circle cx="1.5" cy="11.5" r="1.5" fill="currentColor" />
      <circle cx="6.5" cy="1.5" r="1.5" fill="currentColor" />
      <circle cx="6.5" cy="6.5" r="1.5" fill="currentColor" />
      <circle cx="6.5" cy="11.5" r="1.5" fill="currentColor" />
    </svg>
  </div>
);

export default Handlebar;
